import React from "react";
import { IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Modal from "repoV2/components/common/Modal/Modal";
import useGetFormData from "repoV2/features/Common/modules/FormData/utils/useGetFormData";
import { IMultipleUsersHelpers } from "repoV2/features/Common/modules/FormData/interfaces/MultipleUserHelpers.interfaces";
import {
    FORM_KEYS,
    multiple_users_helpers_keys,
} from "repoV2/features/Common/modules/FormData/FormData.constants";
import useMultipleUserDetails from "../../utils/useMultipleUserDetails";
import UserDetailsForm from "../UserDetailsForm/UserDetailsForm";
import CheckoutButton from "../../../../../../../CheckoutButton/CheckoutButton";
import styles from "./UserDetailsModal.module.scss";

const UserDetailsModal = () => {
    const {
        handleSaveUserDetailsModalClick,
        handleCloseUserDetailsModalClick,
        currentUserId,
    } = useMultipleUserDetails();

    const preEditUserDetails = useGetFormData<
        IMultipleUsersHelpers["preEditUserDetails"]
    >({
        key: `${FORM_KEYS.multiple_users_helpers}.${multiple_users_helpers_keys.pre_edit_user_details}`,
    });

    const isUserDetailsFormOpen = useGetFormData<
        IMultipleUsersHelpers["isUserDetailsFormOpen"]
    >({
        key: `${FORM_KEYS.multiple_users_helpers}.${multiple_users_helpers_keys.is_user_details_form_open}`,
    });

    if (!isUserDetailsFormOpen) {
        return null;
    }

    const renderContent = (
        <div className={styles.mainModalContainer}>
            <div className={styles.modalHeaderStyle}>
                <div>{`${
                    preEditUserDetails.userIdToEdit ? "Edit" : "Add"
                } Person`}</div>
                <IconButton
                    onClick={handleCloseUserDetailsModalClick}
                    className={styles.iconButtonStyle}
                >
                    <CloseRoundedIcon className={styles.closeIconStyle} />
                </IconButton>
            </div>
            <div className={styles.modalBodyStyle}>
                <div className={styles.modlInnerBodyStyle}>
                    <UserDetailsForm userId={currentUserId} />
                </div>
            </div>
            <div className={styles.modalFooterStyle}>
                <CheckoutButton
                    onClick={handleSaveUserDetailsModalClick}
                    type="button"
                >
                    Save
                </CheckoutButton>
            </div>
        </div>
    );
    return (
        <>
            <Modal
                open={isUserDetailsFormOpen}
                onClose={handleCloseUserDetailsModalClick}
                classes={{
                    root: styles.RootModalClass,
                }}
            >
                {renderContent}
            </Modal>
        </>
    );
};

export default UserDetailsModal;
